export default __webpack_public_path__ + "static/og-image-1d4847fc919917b6b506b866266e6ef1.png";